import { useEffect, useState } from "react";
import { withAppContext } from "src/store/initAppContext";
import styled, { withTheme } from "styled-components";
import { Link } from "react-router-dom";
import { getDamain } from "src/util/commonfun";

function AboutUFun88(props: any) {
    const [sitename, setsitename] = useState('')
    const { app: { brandId } } = props;

    let domainURL = getDamain(brandId);
    const domain = brandId === 31 || brandId === 32 ? 'Yolo247' : (brandId == 39 || brandId == 40) ? 'Fomo7' : brandId === 33 ? 'IW247' :brandId === 46 ? 'Fun88': brandId === 47 ? 'Fun88':'Betdaily';

    useEffect(() => {
        window.scrollTo(0, 0)

        switch (brandId) {
            case 31:
                setsitename('yolo247')
                break;
            case 32:
                setsitename('yolo247')
                break;
            case 33:
                setsitename('IW247')
                break;
            case 34:
                setsitename('betdaily')
                break;
            case 39:
                setsitename('FOMO7')
                break;
            case 40:
                setsitename('FOMO7')
                break;
            case 46:
                setsitename('FUN88')
                break;
            case 47:
                setsitename('FUN88')
                break;
            default:
                setsitename('')
                break;
        }
    }, [])

    return (
        <>
            <h1 className="aboutHeading">About Us</h1>
            <p>{sitename} is a leading online gambling platform that offers a variety of fun and exciting gaming products from sportsbook, exchange, in-play sports betting, live casino, slot games, instant games and more! </p>

            <h2>What we do?</h2>
            <ul>
                <li>We provide betting IDs through WhatsApp for both casino & sports, with 24x7 customer support. </li>
                <li>We offer 700+ online games, which are available at your fingertips. </li>
                <li>We provide odds for all the national, regional & international sporting events. </li>
            </ul>

            <h2>A Credible Online Gambling ID Provider in India</h2>
            <p>FUN88 is a fully registered gambling and entertainment company. Being certified and governed by credible gambling bodies assures all members that join and play with FUN88 confirms to standards set of regulation in internet gambling.</p>
            <p>To offer our members the latest online betting technology and the best gaming experience, FUN88 partners with a variety of prominent gaming platforms. </p>

            <h2>Our Services</h2>
            {/* <p>We provide 700+ casino games and <Link to="/betting-exchange">sports betting</Link> options.</p> */}
            <p>We provide 700+ casino games and sports betting options.</p>

            <h3>Casino:</h3>
            <ul>
                <li>Live Casino</li>
                <li>Instant Games</li>
                <li>Slots</li>
            </ul>

            <h3>Sports Betting:</h3>
            <ul>
                <li>Exchange</li>
                <li>Sportsbook</li>
            </ul>

            <h3>Our Bonuses</h3>
            <ul>
                <li>Welcome Bonus - 488%</li>
                <li>Redeposit Bonus - 4%</li>
                <li>Cashback Bonus - 4%</li>
                <li>Referral Bonus - 24%</li>
            </ul>

            <h3>Our Policies</h3>
            <ul>
                <li>KYC Policy</li>
                <li>Anti-Money Laundering Policy</li>
                <li>Self-Exclusion Policy</li>
                <li>Responsible Gaming</li>
                <li>Privacy Policy</li>
            </ul>

            <p>We have partnered with various elite clubs, teams, and franchises across the world for various sporting events. We believe in keeping the fun alive, amid all the things that we do in our daily lives.</p>
            <p>Welcome to the world of infinite fun. Welcome to FUN88.</p>

            <p><strong>Let's begin today!</strong></p>
            <p><Link to="/login">Start winning now.</Link></p>
        </>
    )
}

export default withTheme(withAppContext(AboutUFun88));
